/** biome-ignore-all lint/security/noDangerouslySetInnerHtml: <explanation> */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import type {DefaultNodeTypes, SerializedBlockNode, SerializedLinkNode,} from "@payloadcms/richtext-lexical";
import type React from "react";
import {cn} from "@/utilities/ui";
import "./index.scss";
import {
	type JSXConvertersFunction,
	LinkJSXConverter,
	RichText as RichTextConverter,
} from "@payloadcms/richtext-lexical/react";

import {useLocale} from "next-intl";
import type {SanitizedConfig} from "payload";
import {CTABlock} from "@/blocks/CTABlock/Component";
import {TextHTMLConverter} from "@/components/RichText/converters/textConverter";

type NodeTypes = DefaultNodeTypes | SerializedBlockNode;
const internalDocToHref = ({ linkNode }: { linkNode: SerializedLinkNode }) => {
	const locale: "en" | "nl" | "fr" = useLocale() as "en" | "nl" | "fr";
	const doc = linkNode.fields.doc;
	if (!doc || !doc.value || typeof doc.value !== "object" || !("slug" in doc.value) || !doc.value.slug) {
		return "#";
	}
	const { value, relationTo } = doc;
	const slug = value.slug;
	if (relationTo === "cases") {
		return `/${locale}/cases/${slug}`;
	} else if (relationTo === "insights") {
		return `/${locale}/insights/${slug}`;
	} else {
		return `/${locale}/${slug}`;
	}
};

const createAnchorId = (text: string) => {
	return text
		.toLowerCase()
		.replace(/\s+/g, "-")
		.replace(/[^a-z0-9-]/g, "");
};

type Props = {
	className?: string;
	data: any;
	enableGutter?: boolean;
	enableProse?: boolean;
	table?: boolean;
};

const config: SanitizedConfig = {} as SanitizedConfig;

export default function RichText(props: Props) {
	const {
		data,
		className,
		enableProse = false,
		enableGutter = false,
		table,
	} = props;

	const jsxConverters: JSXConvertersFunction<NodeTypes> = ({
		defaultConverters,
	}) => ({
		...defaultConverters,
		...TextHTMLConverter,
		...LinkJSXConverter({ internalDocToHref }),
		blocks: {
			cta: ({ node }: { node: any }) => {
				return <CTABlock {...node.fields} />;
			},
		},
	});

	// const html = convertLexicalToHTML({
	// 	data: data,
	// 	converters: (({ defaultConverters }) => ({
	// 		...defaultConverters,
	// 		...TextHTMLConverter,
	// 		...jsxConverters,
	// 	})) as HTMLConvertersFunction<DefaultNodeTypes | SerializedBlockNode>,
	// });

	return (
		<RichTextConverter
			data={data}
			converters={jsxConverters}
			className={cn("payload-richtext", className)}
		/>
	);
}
